export const ENDPOINTS = {
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  visitPatientInstructions: (id) => `api/v1/visits/${id}/patientinstructions`,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  visitPatientNotes: (id) => `api/v1/visits/${id}/notes`,
}
